import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { Box } from '@mui/material';
import KeyboardArrowUpRounded from '@mui/icons-material/KeyboardArrowUpRounded';
import { tokens } from '../../theme';

const ScrollToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <Box
          component={motion.button}
          type="button"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.6 }}
          whileHover={{ y: -3 }}
          sx={{
            position: 'fixed',
            right: { xs: 16, md: 24 },
            bottom: { xs: 16, md: 24 },
            zIndex: 1000,
            width: 48,
            height: 48,
            borderRadius: '50%',
            border: 'none',
            cursor: 'pointer',
            display: 'grid',
            placeItems: 'center',
            bgcolor: tokens.ink,
            color: '#fff',
            boxShadow: '0 12px 28px -12px rgba(13,27,46,.6)',
            '&:focus-visible': { outline: `3px solid ${tokens.foil}`, outlineOffset: 3 },
          }}
        >
          <KeyboardArrowUpRounded />
        </Box>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;
